import dayjs from 'core/utils/dayjs';
import { SPONSORED_OFFERS_GET_FAILURE, SPONSORED_OFFERS_GET_SUCCESS } from '../actions/types';

import sponsoredOffersConfig from '../configs';

const { stopDateTimeFormat } = sponsoredOffersConfig;

const initialState = {
  config: sponsoredOffersConfig,
  defaults: {
    isLoaded: false,
    isLoading: false,
    data: [],
  },
};

const handleResponse = (response) => (
  response.map((item) => ({
    ...item,
    expiresToDisplay: dayjs.parseZone(item.stopDatetime).format(stopDateTimeFormat),
  }))
);

const sponsoredOffers = (state = initialState, action) => {
  const namespaceId = action?.options?.namespace || action?.context?.options?.namespace || 'default';
  const namespace = `namespace-${namespaceId}`;
  const { defaults } = state;
  const { [namespace]: namespaceState = defaults } = state;

  switch (action.type) {
    case SPONSORED_OFFERS_GET_SUCCESS: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: handleResponse(action.payload.response),
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case SPONSORED_OFFERS_GET_FAILURE: {
      return {
        ...state,
        [namespace]: {
          ...namespaceState,
          data: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      if (options.success === SPONSORED_OFFERS_GET_SUCCESS) {
        return {
          ...state,
          [namespace]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};

export default sponsoredOffers;
